import { useEffect, useState } from 'react';

import useFetchFulfilmentProviders from './useFetchFulfilmentProviders';

const useFulfilmentProvidersSelect = () => {
  const { fulfilmentProviders } = useFetchFulfilmentProviders();

  const [selectedFulfilmentProvider, setSelectedFulfilmentProvider] =
    useState('');

  const [validationError, setValidationError] = useState('');

  const onValidate = () => {
    let error = '';

    if (!selectedFulfilmentProvider) {
      error = 'Field is required';
    }

    setValidationError(error);
    return error === '';
  };

  useEffect(() => {
    if (fulfilmentProviders) {
      setSelectedFulfilmentProvider(
        fulfilmentProviders[0].fulfilment_provider_id,
      );
    }
  }, [fulfilmentProviders]);

  return {
    validationError,
    fulfilmentProviders,
    selectedFulfilmentProvider,
    setSelectedFulfilmentProvider,
    onValidate,
  };
};

export default useFulfilmentProvidersSelect;
